'use client';
import { useMemo, useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const CircleMatrix = () => {
  const colors = [' #0063FF', ' #B3D1FF', 'hsl(0, 0%, 96%)'];
  const [count, setCount] = useState(0);
  const size = 60;

  useEffect(() => {
    const handleResize = () => {
      let windowHeight = window.innerHeight * 0.5;
      let windowWidth = window.innerWidth * 0.3;
      let countHeight = Math.floor(windowHeight / size);
      let countWidth = Math.floor(windowWidth / size);
      setCount(countHeight * countWidth);
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [size]);

  const matrix = useMemo(() => {
    return Array.from({ length: count }, (_, i) => ({
      id: i,
      initialScale: Math.random() * 0.5 + 0.5,
      delay: Math.random() * 0.5,
      backgroundColor: colors[Math.floor(Math.random() * colors.length)],
    }));
  }, [count]);

  return (
    <div className="flex h-full w-full items-center justify-center pl-10">
      <div className="flex flex-wrap gap-2">
        {matrix.map(item => (
          <motion.div
            key={item.id}
            style={{
              width: size,
              height: size,
              borderRadius: '50%',
              backgroundColor: item.backgroundColor,
            }}
            initial={{ scale: item.initialScale, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{
              delay: item.delay,
              bounce: 0.6,
              duration: 1.5,
              type: 'spring',
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default CircleMatrix;
